import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
  },
  datagrid: {
  },
}));

export default useStyles;
